import type { UscPromotionType } from "../../shared-logic/types/UscCommonTypes";
import { formatDateIntl } from "../../shared-logic/utils/uscUtils";
import type { UscStateType } from "../redux/store";
import { getUscLabel } from "./labels";

type UscPromotionTooltip = {
    state: UscStateType;
    promotionDisclaimer: UscPromotionType;
    cultureName: string;
};

export const formatFromUntilLabel = ({
    state,
    promotionDisclaimer,
    cultureName,
}: UscPromotionTooltip): string | null => {
    const { effectiveTo, effectiveFrom } = promotionDisclaimer;

    const formattedEffectiveFrom = formatDateIntl(effectiveFrom, cultureName);
    const formattedEffectiveTo = formatDateIntl(effectiveTo, cultureName);

    if (effectiveTo && effectiveFrom) {
        return getUscLabel(state, "uscPromoFromUntilDate", {
            from: formattedEffectiveFrom,
            until: formattedEffectiveTo,
        });
    } else if (effectiveTo && !effectiveFrom) {
        return getUscLabel(state, "uscPromoFromDate", { from: formattedEffectiveFrom });
    } else if (!effectiveTo && effectiveFrom) {
        return getUscLabel(state, "uscPromoUntilDate", { until: formattedEffectiveTo });
    }

    return null;
};

export const getUscPromotionDisclaimer = ({ state, promotionDisclaimer, cultureName }: UscPromotionTooltip): string => {
    const { label, legalDisclaimer, effectiveTo, effectiveFrom } = promotionDisclaimer;

    let result = "";

    // Used as a title field, we append a colon to the label
    // e.g. "Promotion information: "
    if (label) {
        result += `${label}: `;
    }

    // Actual promotion disclaimer
    if (legalDisclaimer) {
        result += legalDisclaimer;
    }

    if (effectiveTo || effectiveFrom) {
        const fromUntilLabel = formatFromUntilLabel({ state, promotionDisclaimer, cultureName });

        // The space added before the label in the template literal is intentional, otheriwse
        // the label would be concatenated to the legal disclaimer without a space
        if (fromUntilLabel) {
            result += ` ${fromUntilLabel}`;
        }
    }

    return result;
};
